//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const value = ref(30)
    const rules = [v => v <= 40 || 'Only 40 in stock']

    return { value, rules }
  },
}
